import React from 'react'
import { utcToLocalTime } from '../../../../../Studio-Services/Studio_Services';

export default function MemberInActivePurchasedPasses({
    familyRecurringInactiveItem,
    familyTimeFrameInactiveItem,
    familyPunchInactiveItem,
    familyRecurringInActivePunch,
    studioData,
    checkCardExpire,
    changeStatus,
    changePassInfo
}) {
    const recurringInactiveItem = Array.isArray(familyRecurringInactiveItem) ? familyRecurringInactiveItem : [];
    const timeFrameInactiveItem = Array.isArray(familyTimeFrameInactiveItem) ? familyTimeFrameInactiveItem : [];
    const punchInactiveItem = Array.isArray(familyPunchInactiveItem) ? familyPunchInactiveItem : [];
    const recurringInActivePunch = Array.isArray(familyRecurringInActivePunch) ? familyRecurringInActivePunch : [];
    return (
        <>
            <h4 className="title text-capitalize mt-5">In-Active Purchased Passes </h4>

            {/* ****** Family Inactive Recurring Passes  ******** */}

            <h4 className="group_card mt-3">Recurring Membership</h4>
            {recurringInactiveItem.length > 0 &&
                <div className="row pt-4" >
                    {recurringInactiveItem.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.full_price} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                {/* <div className="row mt-4">
                                                                                                    <div className="col-12">
                                                                                                        <p>Remaining Days : {lists.remaining_count} of {lists.total_count}</p>
                                                                                                    </div>
                                                                                                </div> */}
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Start Date : {utcToLocalTime(lists.start_date_utc)} </p>
                                        {(lists.pass_cancellation_date == '') &&
                                            <div>
                                                <p className="font-12">Renewal Date : {utcToLocalTime(lists.end_date_utc)} </p>
                                            </div>
                                        }
                                        {lists.pass_cancellation_date != '' &&
                                            <div>
                                                <p className="font-12">Cancellation Date : {lists.pass_cancellation_date} </p>
                                            </div>
                                        }
                                    </div>
                                    <div className="col-4">
                                        {lists.is_recurring_stop == 0 &&
                                            <button className="btn btn-brandred text-right" onClick={() => { changeStatus(1, lists.booking_pass_id, lists.pass_id, lists) }}
                                            >Expired
                                            </button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringInactiveItem.length == 0 &&
                <div>  <p className="text-center">No Records Found</p> </div>
            }
            {/* ****** Family Inactive Time Frame Passes  ******** */}

            <h4 className="group_card mt-3">Time Frame</h4>
            {timeFrameInactiveItem.length > 0 &&
                <div className="row pt-4" >
                    {timeFrameInactiveItem.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">
                                    <div className="col-m-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-m-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Expiration Date :
                                            {utcToLocalTime(lists.end_date_utc)} <button type="button"
                                                className="fa fa-edit" data-toggle="modal"
                                                data-target="#passInfoModel"
                                                onClick={() => changePassInfo(lists)}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {timeFrameInactiveItem.length == 0 &&
                <div>  <p className="text-center">No Records Found</p></div>
            }

            {/* ****** Family Inactive Punch Passes  ******** */}

            <h4 className="group_card mt-3">Punch Card</h4>
            {punchInactiveItem.length > 0 &&
                <div className="row pt-4" >
                    {punchInactiveItem.map((lists) => (
                        <div className="col-md-6 col-lg-4" >
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} alt="" className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists) }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :

                                            {utcToLocalTime(lists.end_date_utc)}
                                            {/* // .format('MMM d y')} */}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchInactiveItem.length == 0 &&
                <div> <p className="text-center">No Records Found</p> </div>
            }



            {/* ****** Family Recurring Inactive Punch Passes  ******** */}

            <h4 className="group_card mt-3">Recurring Punch Card</h4>
            {recurringInActivePunch.length > 0 &&
                <div className="row pt-4" >
                    {recurringInActivePunch.map((lists) => (
                        <div className="col-md-6 col-lg-4" >
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} alt="" className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists) }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :

                                            {utcToLocalTime(lists.end_date_utc)}
                                            {/* // .format('MMM d y')} */}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringInActivePunch.length == 0 &&
                <div>   <p className="text-center">No Records Found</p> </div>
            }

        </>
    )
}
